import { Button } from 'fluxo-ui';
import { PlayIcon } from 'fluxo-ui/icons';

import { LiveQuizParticipant } from '../../../types/index.ts';

import JoinCodePanel from './JoinCodePanel';

interface LiveQuizLobbyProps {
    joinCode: string;
    participants: LiveQuizParticipant[];
    totalQuestions: number;
    onStart: () => void;
}

const LiveQuizLobby: React.FC<LiveQuizLobbyProps> = ({ joinCode, participants, totalQuestions, onStart }) => (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        <section className="rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6">
            <JoinCodePanel joinCode={joinCode} />

            <div className="mt-6 pt-5 border-t border-slate-200 dark:border-slate-800">
                <p className="text-sm text-slate-500 dark:text-slate-400">
                    {totalQuestions} {totalQuestions === 1 ? 'question' : 'questions'} ready
                </p>
                <Button
                    label={participants.length > 0 ? `Start quiz with ${participants.length}` : 'Start quiz'}
                    leftIcon={PlayIcon}
                    variant="primary"
                    size="lg"
                    className="mt-3 w-full"
                    disabled={participants.length === 0}
                    onClick={onStart}
                />
                {participants.length === 0 && (
                    <p className="mt-2 text-center text-xs text-slate-500 dark:text-slate-400">
                        Waiting for the first player to join
                    </p>
                )}
            </div>
        </section>

        <section className="rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6">
            <h2 className="text-sm font-semibold text-slate-900 dark:text-white">
                Players <span className="tabular-nums text-slate-500 dark:text-slate-400">({participants.length})</span>
            </h2>

            {participants.length === 0 ? (
                <p className="mt-6 text-center text-sm text-slate-500 dark:text-slate-400">
                    Nobody here yet. Share the join code to fill the room.
                </p>
            ) : (
                <ul className="mt-4 flex flex-wrap gap-2">
                    {participants.map((participant) => (
                        <li
                            key={participant.participantId}
                            className="flex items-center gap-1.5 rounded-full border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 px-3 py-1.5 text-sm text-slate-700 dark:text-slate-300"
                        >
                            <span
                                className={
                                    participant.connected
                                        ? 'w-1.5 h-1.5 rounded-full bg-emerald-500'
                                        : 'w-1.5 h-1.5 rounded-full bg-slate-400 dark:bg-slate-600'
                                }
                            />
                            {participant.name}
                        </li>
                    ))}
                </ul>
            )}
        </section>
    </div>
);

export default LiveQuizLobby;
